<template>
    <dev-mode @ready="onReadeDevMode" @start="onStartDevMode"/>
</template>

<script setup lang="ts">
    const emit = defineEmits(['data-loading']);

    const onStartDevMode = (): void => {
        emit("data-loading", true);
    };
    const onReadeDevMode = (): void  => {
        emit("data-loading", false);
    };
</script>
